module.exports = __webpack_public_path__ + "img/3_173.a0365e25.png";